import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT, RED } from "./ExplainerSection";

const ResponsiveIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Eine Webseite, perfekt auf jedem Gerät">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Desktop */}
    <rect x="40" y="50" width="170" height="110" rx="6" fill="#fff" stroke={NAVY} strokeWidth="2.5" />
    <rect x="105" y="160" width="40" height="8" fill={NAVY} />
    <rect x="85" y="168" width="80" height="5" fill={NAVY} />
    <rect x="52" y="62" width="146" height="20" fill={NAVY} />
    <rect x="52" y="90" width="90" height="8" fill={CYAN} />
    <rect x="52" y="104" width="146" height="4" fill="#D3DEE6" />
    <rect x="52" y="112" width="130" height="4" fill="#D3DEE6" />
    <rect x="52" y="126" width="50" height="16" fill={LIME} />
    {/* Tablet */}
    <rect x="235" y="70" width="80" height="110" rx="8" fill="#fff" stroke={NAVY} strokeWidth="2.5" />
    <rect x="243" y="80" width="64" height="14" fill={NAVY} />
    <rect x="243" y="100" width="44" height="6" fill={CYAN} />
    <rect x="243" y="112" width="64" height="3" fill="#D3DEE6" />
    <rect x="243" y="119" width="56" height="3" fill="#D3DEE6" />
    <rect x="243" y="130" width="34" height="12" fill={LIME} />
    {/* Phone */}
    <rect x="335" y="90" width="42" height="80" rx="7" fill="#fff" stroke={NAVY} strokeWidth="2.5" />
    <rect x="341" y="98" width="30" height="10" fill={NAVY} />
    <rect x="341" y="112" width="22" height="4" fill={CYAN} />
    <rect x="341" y="120" width="30" height="2.5" fill="#D3DEE6" />
    <rect x="341" y="126" width="26" height="2.5" fill="#D3DEE6" />
    <rect x="341" y="134" width="18" height="8" fill={LIME} />
    {/* Sync pulses */}
    {[220, 322].map((x, i) => (
      <circle key={i} cx={x} cy="120" r="4" fill={LIME}>
        <animate attributeName="opacity" values="0.2;1;0.2" dur="1.6s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
      </circle>
    ))}
    <text x="200" y="215" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>GLEICHER INHALT · PERFEKT ANGEPASST</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      MOBILE-FIRST · 70 % KOMMEN VOM SMARTPHONE
    </text>
  </svg>
);

const SpeedIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Ladezeit unter 2 Sekunden">
    <rect width="400" height="260" fill={INK} />
    {/* Gauge */}
    <path d="M 80 180 A 120 120 0 0 1 320 180" stroke="#2A3542" strokeWidth="20" fill="none" strokeLinecap="round" />
    <path d="M 80 180 A 120 120 0 0 1 320 180" stroke="url(#speedGrad)" strokeWidth="20" fill="none" strokeLinecap="round" strokeDasharray="378" strokeDashoffset="264" />
    <defs>
      <linearGradient id="speedGrad">
        <stop offset="0%" stopColor={LIME} />
        <stop offset="100%" stopColor={CYAN} />
      </linearGradient>
    </defs>
    <line x1="200" y1="180" x2="120" y2="115" stroke="#fff" strokeWidth="4" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" values="0 200 180;28 200 180;0 200 180" dur="3s" repeatCount="indefinite" />
    </line>
    <circle cx="200" cy="180" r="9" fill="#fff" />
    <text x="200" y="150" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="34" fontWeight="900" fill={LIME}>{"< 2s"}</text>
    <text x="85" y="212" fontFamily="ui-monospace, monospace" fontSize="9" fill={LIME} fontWeight="bold">SCHNELL</text>
    <text x="270" y="212" fontFamily="ui-monospace, monospace" fontSize="9" fill={RED}>LANGSAM</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      CORE WEB VITALS IM GRÜNEN BEREICH
    </text>
  </svg>
);

const LocalSeoIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Lokales SEO: gefunden werden in der Region">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Map grid */}
    {[0, 1, 2, 3, 4].map((i) => (
      <g key={i}>
        <line x1={60 + i * 70} y1="35" x2={60 + i * 70} y2="200" stroke="#D3DEE6" strokeWidth="1.5" />
        <line x1="40" y1={45 + i * 40} x2="360" y2={45 + i * 40} stroke="#D3DEE6" strokeWidth="1.5" />
      </g>
    ))}
    {/* Radiating pin */}
    <circle cx="200" cy="110" r="30" fill="none" stroke={CYAN} strokeWidth="2">
      <animate attributeName="r" values="20;70" dur="2.5s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.9;0" dur="2.5s" repeatCount="indefinite" />
    </circle>
    <path d="M 200 70 q 26 0 26 26 q 0 20 -26 44 q -26 -24 -26 -44 q 0 -26 26 -26 z" fill={NAVY} />
    <circle cx="200" cy="96" r="10" fill={LIME} />
    {/* City labels */}
    <text x="90" y="70" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>FULDA</text>
    <text x="290" y="65" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>KASSEL</text>
    <text x="80" y="180" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>WÜRZBURG</text>
    <text x="290" y="180" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>ERFURT</text>
    {/* Magnifier */}
    <circle cx="315" cy="115" r="20" fill="none" stroke={NAVY} strokeWidth="3.5" />
    <line x1="330" y1="130" x2="348" y2="148" stroke={NAVY} strokeWidth="4" strokeLinecap="round" />
    <text x="315" y="120" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fontWeight="900" fill={NAVY}>#1</text>
    <text x="200" y="228" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>„WEBDESIGN + IHRE STADT“ → SIE</text>
    <text x="200" y="248" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      LOKALES SEO AB TAG 1
    </text>
  </svg>
);

const CmsIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="CMS: Inhalte selbst pflegen">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Browser */}
    <rect x="50" y="35" width="300" height="175" rx="8" fill="#fff" stroke={NAVY} strokeWidth="2" />
    <rect x="50" y="35" width="300" height="24" rx="8" fill={NAVY} />
    <circle cx="66" cy="47" r="4" fill={LIME} />
    <circle cx="80" cy="47" r="4" fill={CYAN} />
    <text x="105" y="51" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff">IHRE-WEBSEITE.DE/ADMIN</text>
    {/* Editable content */}
    <rect x="70" y="75" width="120" height="60" fill={CYAN} opacity="0.25" />
    <rect x="70" y="75" width="120" height="60" fill="none" stroke={CYAN} strokeWidth="1.5" strokeDasharray="5 4" />
    <text x="130" y="110" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={NAVY}>BILD TAUSCHEN</text>
    <rect x="205" y="80" width="125" height="7" fill={INK} />
    <rect x="205" y="95" width="110" height="4" fill="#D3DEE6" />
    <rect x="205" y="104" width="118" height="4" fill="#D3DEE6" />
    <rect x="205" y="113" width="95" height="4" fill="#D3DEE6" />
    {/* Blinking caret */}
    <rect x="303" y="110" width="2.5" height="10" fill={NAVY}>
      <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
    </rect>
    {/* Pencil */}
    <g transform="translate(280, 140) rotate(40)">
      <rect x="0" y="0" width="14" height="45" fill={LIME} stroke={INK} strokeWidth="1.5" />
      <polygon points="0,45 14,45 7,60" fill="#F5D08C" stroke={INK} strokeWidth="1.5" />
      <animateTransform attributeName="transform" type="translate" values="280 140;255 150;280 140" dur="2.5s" repeatCount="indefinite" additive="replace" />
    </g>
    {/* Save button */}
    <rect x="70" y="160" width="90" height="24" rx="3" fill={LIME}>
      <animate attributeName="opacity" values="1;0.7;1" dur="2s" repeatCount="indefinite" />
    </rect>
    <text x="115" y="176" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fontWeight="bold" fill={INK}>SPEICHERN ✓</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      TEXTE & BILDER SELBST PFLEGEN · OHNE AGENTUR
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: ResponsiveIllu, title: "Ein Design, jedes Gerät", desc: "Über 70 % Ihrer Besucher kommen vom Smartphone. Wir bauen mobile-first: Ihre Webseite sieht auf dem Handy genauso überzeugend aus wie auf dem großen Monitor.", testId: "responsive" },
  { step: "02", illu: SpeedIllu, title: "Schnelligkeit, die Google belohnt", desc: "Jede Sekunde Ladezeit kostet Besucher und Ranking. Unsere Seiten laden in unter 2 Sekunden – Core Web Vitals im grünen Bereich, das spart bares Geld bei Google Ads.", testId: "speed" },
  { step: "03", illu: LocalSeoIllu, title: "Gefunden werden, wo Ihre Kunden sind", desc: "Wer „Handwerker Fulda“ googelt, soll Sie finden – nicht die Konkurrenz aus Berlin. Lokales SEO mit Google Business Profil und Schema.org-Daten ist bei uns Standard.", testId: "localseo" },
  { step: "04", illu: CmsIllu, title: "Sie pflegen Inhalte selbst", desc: "Texte ändern, Bilder tauschen, Blog-Beiträge schreiben – ohne Agentur, ohne Wartezeit. Ihr CMS ist so einfach wie eine Textverarbeitung. Schulung inklusive.", testId: "cms" },
];

export const WebdesignExplainers = () => (
  <ExplainerSection
    eyebrow="So entsteht eine Webseite, die arbeitet"
    titleA="Vier Erfolgsfaktoren."
    titleB="Einfach erklärt."
    intro="Eine schöne Webseite reicht nicht – sie muss gefunden werden, schnell laden und sich pflegen lassen. Hier sehen Sie visuell, worauf es wirklich ankommt."
    items={ITEMS}
    testId="webdesign-explainers"
  />
);
